import { useLayoutEffect, useRef } from "react";
/**
 * Returns a size of a target element. This hook will update the `Size` if
 * the deps are updated, but this would not be a good option for complicated
 * usecases(dynamic size, animation, ...). In that case, please use other
 * libraries (e.g. react-cool-dimensions)
 */
export function useGetElementSize(deps) {
    var elementRef = useRef(null);
    var minimizedSize = useRef();
    useLayoutEffect(function () {
        if (elementRef.current) {
            minimizedSize.current = {
                width: elementRef.current.offsetWidth,
                height: elementRef.current.offsetHeight,
            };
        }
    }, deps);
    return [elementRef, minimizedSize.current];
}
